var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "log-in",
    d: "M28,7.5v17A3.50424,3.50424,0,0,1,24.5,28h-12A3.50424,3.50424,0,0,1,9,24.5V20h3v4.5a.50641.50641,0,0,0,.5.5h12a.50641.50641,0,0,0,.5-.5V7.5a.50641.50641,0,0,0-.5-.5h-12a.50641.50641,0,0,0-.5.5V12H9V7.5A3.50424,3.50424,0,0,1,12.5,4h12A3.50424,3.50424,0,0,1,28,7.5ZM14,19.98877a.99989.99989,0,0,0,1.57019.82129l5.74628-3.98877a.99959.99959,0,0,0,0-1.64258l-5.74628-3.98877A.99989.99989,0,0,0,14,12.01123V14H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.bff2a6b82c7f2d31dba8722b633dc43e.svg";
export { ForwardRef as ReactComponent };